export const SUBJECTS = [
  {
    id: 'math-foundations-1',
    name: 'Math Foundations 1',
    description: 'Counting, place value, addition, and subtraction for the youngest learners.',
    category: 'math',
    available: true,
    popularity: 55,
    releasedAt: '2026-05-13',
  },
  {
    id: 'math-foundations-2',
    name: 'Math Foundations 2',
    description: 'Multiplication tables, division, and the building blocks of fractions.',
    category: 'math',
    available: true,
    popularity: 60,
    releasedAt: '2026-05-13',
  },
  {
    id: 'math-foundations-3',
    name: 'Math Foundations 3',
    description: 'Decimals, mixed numbers, and basic measurement built on solid arithmetic.',
    category: 'math',
    available: true,
    popularity: 65,
    releasedAt: '2026-05-13',
  },
  {
    id: 'math-foundations-4',
    name: 'Math Foundations 4',
    description: 'Ratios, rates, percents, and rational numbers, the final bridge to algebra.',
    category: 'math',
    available: true,
    popularity: 60,
    releasedAt: '2026-05-13',
  },
  {
    id: 'arithmetic-mastery',
    name: 'Arithmetic Mastery',
    description: 'Comprehensive arithmetic review for confident pre-algebra readiness.',
    category: 'math',
    available: true,
    popularity: 70,
    releasedAt: '2026-05-13',
  },
  {
    id: 'intro-pre-algebra',
    name: 'Intro to Pre-Algebra',
    description: 'Variables, simple equations, and the first taste of algebraic thinking.',
    category: 'math',
    available: true,
    popularity: 78,
    releasedAt: '2026-05-13',
  },
  {
    id: 'pre-algebra',
    name: 'Pre-Algebra',
    description: 'Build a rock-solid foundation in arithmetic, fractions, ratios, and intro to variables.',
    category: 'math',
    available: true,
    badge: 'Popular',
    popularity: 80,
    releasedAt: '2026-04-01',
  },
  {
    id: 'algebra-1',
    name: 'Algebra 1',
    description: 'Master linear equations, inequalities, functions, and quadratics in 11 weeks.',
    category: 'math',
    available: true,
    badge: 'Bestseller',
    popularity: 95,
    releasedAt: '2026-04-01',
  },
  {
    id: 'geometry',
    name: 'Geometry',
    description: 'Shapes, proofs, theorems, and spatial reasoning.',
    category: 'math',
    available: true,
    popularity: 75,
    releasedAt: '2026-05-13',
  },
  {
    id: 'algebra-2',
    name: 'Algebra 2',
    description: 'Polynomials, exponentials, logarithms, and complex functions.',
    category: 'math',
    available: true,
    popularity: 72,
    releasedAt: '2026-05-13',
  },
  {
    id: 'pre-calculus',
    name: 'Pre-Calculus',
    description: 'Trigonometry, advanced functions, and limits.',
    category: 'math',
    available: true,
    popularity: 50,
    releasedAt: '2026-05-13',
  },
  {
    id: 'calculus',
    name: 'Calculus',
    description: 'Derivatives, integrals, and applications.',
    category: 'math',
    available: true,
    popularity: 65,
    releasedAt: '2026-05-13',
  },
];

export const CATEGORIES = [
  { id: 'math', name: 'Math' },
];

export const ROLES = [
  { id: 'guardian', name: 'Guardian' },
  { id: 'instructor', name: 'Instructor' },
  { id: 'student', name: 'Student' },
];

export function getSubjectById(id) {
  return SUBJECTS.find((subject) => subject.id === id);
}

export function getRoleById(id) {
  return ROLES.find((role) => role.id === id);
}

export function getCategoryById(id) {
  return CATEGORIES.find((category) => category.id === id);
}

export function getAvailableSubjects() {
  return SUBJECTS.filter((subject) => subject.available);
}